(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  window.location.href = "/";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleat-listicle-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  const MOBILE_BREAKPOINT = 750;
  const MOBILE_GAP = 16;
  const DESKTOP_GAP = 24;
  const DESKTOP_PER_PAGE = 3;
  const SCROLL_END_MS = 160;

  /**
   * @returns {boolean}
   */
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  /**
   * @param {number} value
   * @param {number} pageCount
   * @returns {number}
   */
  function clampPage(value, pageCount) {
    if (pageCount < 1) {
      return 0;
    }

    return Math.max(0, Math.min(pageCount - 1, value));
  }

  /**
   * @param {HTMLElement} panel
   */
  function resetPanel(panel) {
    if (panel && panel.__etrReset) {
      panel.__etrReset();
    }
  }

  /**
   * @param {HTMLElement} panel
   */
  function setupPanel(panel) {
    const track = panel.querySelector('.etr-track');
    const dotsWrap = panel.querySelector('[data-etr-dots]');
    const prev = panel.querySelector('[data-etr-prev]');
    const next = panel.querySelector('[data-etr-next]');

    if (!track || !dotsWrap) {
      return;
    }

    const cards = track.querySelectorAll('.etr-card');
    let lastPage = 0;
    let rafPending = false;
    let scrollEndTimer = null;

    /**
     * @returns {number}
     */
    function getGap() {
      return isMobile() ? MOBILE_GAP : DESKTOP_GAP;
    }

    /**
     * @returns {number}
     */
    function getPageCount() {
      if (!cards.length) {
        return 0;
      }

      if (isMobile()) {
        return cards.length;
      }

      if (cards.length <= DESKTOP_PER_PAGE) {
        return 1;
      }

      return cards.length - DESKTOP_PER_PAGE + 1;
    }

    /**
     * @param {number} page
     */
    function applyPage(page) {
      const pageCount = getPageCount();
      const dots = dotsWrap.querySelectorAll('.etr-dot');

      if (!pageCount) {
        return;
      }

      page = clampPage(page, pageCount);
      lastPage = page;

      dots.forEach(function (dot, index) {
        if (index === page) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    /**
     * @returns {number}
     */
    function getCurrentPage() {
      if (!cards.length) {
        return 0;
      }

      const cardWidth = cards[0].offsetWidth + getGap();
      const currentCardIndex = Math.round(track.scrollLeft / cardWidth);

      return clampPage(currentCardIndex, getPageCount());
    }

    /**
     * @param {number} page
     */
    function scrollToPage(page) {
      page = clampPage(page, getPageCount());

      const card = cards[page];

      if (!card) {
        return;
      }

      window.clearTimeout(scrollEndTimer);
      applyPage(page);
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
    }

    function buildDots() {
      dotsWrap.innerHTML = '';

      const pages = getPageCount();

      for (let page = 0; page < pages; page += 1) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'etr-dot';
        dot.setAttribute('aria-label', 'Go to reviews ' + (page + 1));

        if (page === lastPage) {
          dot.setAttribute('aria-current', 'true');
        }

        dot.addEventListener('click', function () {
          scrollToPage(page);
        });

        dotsWrap.appendChild(dot);
      }
    }

    function reset() {
      lastPage = 0;
      buildDots();
      applyPage(0);
      track.scrollLeft = 0;
    }

    track.addEventListener('scroll', function () {
      if (rafPending) {
        return;
      }

      rafPending = true;

      requestAnimationFrame(function () {
        rafPending = false;
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(function () {
          applyPage(getCurrentPage());
        }, SCROLL_END_MS);
      });
    }, { passive: true });

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToPage(lastPage - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollToPage(lastPage + 1);
      });
    }

    panel.__etrReset = reset;
    buildDots();
    applyPage(0);

    window.addEventListener('resize', function () {
      buildDots();
      applyPage(lastPage);
    });
  }

  /**
   * @param {Element} root
   */
  function init(root) {
    if (!root || root.__etrInit) {
      return;
    }

    root.__etrInit = true;

    const tabs = root.querySelectorAll('[data-etr-tab]');
    const panels = root.querySelectorAll('[data-etr-panel]');

    tabs.forEach(function (button) {
      button.addEventListener('click', function () {
        const key = button.getAttribute('data-etr-tab');

        tabs.forEach(function (tab) {
          tab.setAttribute(
            'aria-selected',
            tab === button ? 'true' : 'false',
          );
        });

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-etr-panel') === key) {
            panel.removeAttribute('hidden');
            resetPanel(panel);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });

    panels.forEach(setupPanel);
  }

  document.querySelectorAll('.etr-section').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('.etr-section') || event.target;
    init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleat-tabbed-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  const MOBILE_BREAKPOINT = 750;
  const MOBILE_GAP = 16;
  const DESKTOP_GAP = 24;
  const DESKTOP_PER_PAGE = 3;
  const SCROLL_END_MS = 160;

  /**
   * @returns {boolean}
   */
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  /**
   * @param {number} value
   * @param {number} pageCount
   * @returns {number}
   */
  function clampPage(value, pageCount) {
    if (pageCount < 1) {
      return 0;
    }

    return Math.max(0, Math.min(pageCount - 1, value));
  }

  /**
   * @param {HTMLElement} panel
   */
  function resetPanel(panel) {
    if (panel && panel.__etrReset) {
      panel.__etrReset();
    }
  }

  /**
   * @param {HTMLElement} panel
   */
  function setupPanel(panel) {
    const track = panel.querySelector('.etr-track');
    const dotsWrap = panel.querySelector('[data-etr-dots]');
    const prev = panel.querySelector('[data-etr-prev]');
    const next = panel.querySelector('[data-etr-next]');

    if (!track || !dotsWrap) {
      return;
    }

    const cards = track.querySelectorAll('.etr-card');
    let lastPage = 0;
    let rafPending = false;
    let scrollEndTimer = null;

    /**
     * @returns {number}
     */
    function getGap() {
      return isMobile() ? MOBILE_GAP : DESKTOP_GAP;
    }

    /**
     * @returns {number}
     */
    function getPageCount() {
      if (!cards.length) {
        return 0;
      }

      if (isMobile()) {
        return cards.length;
      }

      if (cards.length <= DESKTOP_PER_PAGE) {
        return 1;
      }

      return cards.length - DESKTOP_PER_PAGE + 1;
    }

    /**
     * @param {number} page
     */
    function applyPage(page) {
      const pageCount = getPageCount();
      const dots = dotsWrap.querySelectorAll('.etr-dot');

      if (!pageCount) {
        return;
      }

      page = clampPage(page, pageCount);
      lastPage = page;

      dots.forEach(function (dot, index) {
        if (index === page) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    /**
     * @returns {number}
     */
    function getCurrentPage() {
      if (!cards.length) {
        return 0;
      }

      const cardWidth = cards[0].offsetWidth + getGap();
      const currentCardIndex = Math.round(track.scrollLeft / cardWidth);

      return clampPage(currentCardIndex, getPageCount());
    }

    /**
     * @param {number} page
     */
    function scrollToPage(page) {
      page = clampPage(page, getPageCount());

      const card = cards[page];

      if (!card) {
        return;
      }

      window.clearTimeout(scrollEndTimer);
      applyPage(page);
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
    }

    function buildDots() {
      dotsWrap.innerHTML = '';

      const pages = getPageCount();

      for (let page = 0; page < pages; page += 1) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'etr-dot';
        dot.setAttribute('aria-label', 'Go to reviews ' + (page + 1));

        if (page === lastPage) {
          dot.setAttribute('aria-current', 'true');
        }

        dot.addEventListener('click', function () {
          scrollToPage(page);
        });

        dotsWrap.appendChild(dot);
      }
    }

    function reset() {
      lastPage = 0;
      buildDots();
      applyPage(0);
      track.scrollLeft = 0;
    }

    track.addEventListener('scroll', function () {
      if (rafPending) {
        return;
      }

      rafPending = true;

      requestAnimationFrame(function () {
        rafPending = false;
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(function () {
          applyPage(getCurrentPage());
        }, SCROLL_END_MS);
      });
    }, { passive: true });

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToPage(lastPage - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollToPage(lastPage + 1);
      });
    }

    panel.__etrReset = reset;
    buildDots();
    applyPage(0);

    window.addEventListener('resize', function () {
      buildDots();
      applyPage(lastPage);
    });
  }

  /**
   * @param {Element} root
   */
  function init(root) {
    if (!root || root.__etrInit) {
      return;
    }

    root.__etrInit = true;

    const tabs = root.querySelectorAll('[data-etr-tab]');
    const panels = root.querySelectorAll('[data-etr-panel]');

    tabs.forEach(function (button) {
      button.addEventListener('click', function () {
        const key = button.getAttribute('data-etr-tab');

        tabs.forEach(function (tab) {
          tab.setAttribute(
            'aria-selected',
            tab === button ? 'true' : 'false',
          );
        });

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-etr-panel') === key) {
            panel.removeAttribute('hidden');
            resetPanel(panel);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });

    panels.forEach(setupPanel);
  }

  document.querySelectorAll('.etr-section').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('.etr-section') || event.target;
    init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleat-trustpilot-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialise(root) {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;
    root.querySelectorAll('[data-eleat-trustpilot-grid] .trustpilot-widget').forEach(function (widget) {
      if (!widget.querySelector('iframe')) window.Trustpilot.loadFromElement(widget, true);
    });
  }
  function initialisePage() {
    initialise(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePage, { once: true });
  } else {
    initialisePage();
  }
  var bootstrap = document.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]');
  if (bootstrap) bootstrap.addEventListener('load', initialisePage, { once: true });
  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visibility-blocks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const setOrientation = (list) => {
      list.setAttribute('aria-orientation', desktop.matches ? 'horizontal' : 'vertical');
    };
    const initialise = (scope) => {
      scope.querySelectorAll('[data-eleat-visibility-tabs]').forEach((section) => {
        if (section.dataset.eleatTabsReady) return;
        const list = section.querySelector('[role="tablist"]');
        const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
        const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));
        if (!tabs.length) return;
        section.dataset.eleatTabsReady = 'true';
        setOrientation(list);
        const setFocusTarget = (target) => {
          tabs.forEach((tab) => { tab.tabIndex = tab === target ? 0 : -1; });
        };
        const activate = (target) => {
          setFocusTarget(target);
          tabs.forEach((tab) => {
            const selected = tab === target;
            tab.setAttribute('aria-selected', String(selected));
            tab.classList.toggle('active', selected);
          });
          panels.forEach((panel) => {
            const selected = panel.id === target.getAttribute('aria-controls');
            panel.hidden = !selected;
            panel.classList.toggle('active', selected);
          });
        };
        list.addEventListener('click', (event) => {
          const target = event.target.closest('[role="tab"]');
          if (tabs.includes(target)) activate(target);
        });
        list.addEventListener('keydown', (event) => {
          const index = tabs.indexOf(event.target);
          if (index < 0 || event.altKey || event.ctrlKey || event.metaKey) return;
          const previous = desktop.matches ? 'ArrowLeft' : 'ArrowUp';
          const next = desktop.matches ? 'ArrowRight' : 'ArrowDown';
          let target;
          if (event.key === previous) target = tabs[(index + tabs.length - 1) % tabs.length];
          if (event.key === next) target = tabs[(index + 1) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (!target) return;
          event.preventDefault();
          setFocusTarget(target);
          target.focus();
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
    } else {
      initialise(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
    desktop.addEventListener('change', () => {
      document.querySelectorAll('[data-eleat-visibility-tabs] [role="tablist"]').forEach(setOrientation);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
